/**
 * Every fan-facing string the pick screen renders, in one module, so no
 * component under `apps/app/src/features/pick/` contains a copy literal.
 */

export const PICK_SHEET_NAME = "make-a-pick";
export const PICK_SHEET_TITLE = "Make your pick";
export const PICK_OPEN_LABEL = "Make your pick";
export const PICK_CONFIRM_ONE_LABEL = "Confirm pick";
export const PICK_CONFIRM_MANY_LABEL = "Confirm picks";
export const PICK_UPDATE_ONE_LABEL = "Update your pick";
export const PICK_UPDATE_MANY_LABEL = "Update your picks";
export const PICK_CANCEL_LABEL = "Cancel";
// The discard guard, following `CREATE_POOL_DISCARD_*` in
// `apps/app/src/features/createPool/CreatePoolDialog.tsx`. The words differ
// from that one on purpose: a fan taps picks, they do not edit a form, so
// "changes" and "Keep editing" would name the wrong action. The body talks
// about the taps just made, which is true whether this is a first pick or a
// change to picks already confirmed.
export const PICK_DISCARD_TITLE = "Discard your picks?";
export const PICK_DISCARD_BODY = "The picks you just made won't be saved.";
export const PICK_DISCARD_CONFIRM_LABEL = "Discard";
export const PICK_DISCARD_CANCEL_LABEL = "Keep picking";
export const PICK_LOADING_LABEL = "Loading this round";
export const PICK_FAILED_MESSAGE = "We could not load this round.";
export const PICK_RETRY_LABEL = "Try again";
export const PICK_NO_CONTEST_NOTE = "There is no round to pick in right now.";
export const PICK_NO_ENTRY_NOTE =
  "This round is open, but you don't have an entry in this contest, so there's nothing for you to pick.";
// ISSUE-777. SUR-R39 promises a fan who joins mid-contest plays the next
// contest, and Q-777-A settled that the Commissioner starts it. So this line
// says who starts it, and never promises one is already on the way.
export const PICK_NEXT_CONTEST_NOTE =
  "You'll be in the next contest your Commissioner starts.";
export const PICK_ELIMINATED_NOTE =
  "You're out of this contest, so there's nothing to pick.";
export const PICK_SKIPPED_NOTE = "You skipped this round.";
export const PICK_ROUND_LOCKED_NOTE =
  "This round is locked. Here's what you picked.";
export const PICK_CONFIRMED_NOTE = "Your pick is in.";
export const PICK_CONFIRMED_MANY_NOTE = "Your picks are in.";
export const PICK_STALE_BOARD_NOTE =
  "That round moved on while you were picking. We refreshed it for you.";
export const PICK_LOCKED_TILE_LABEL = "Locked";
export const PICK_ALREADY_FINISHED_TILE_LABEL = "Already played";
export const PICK_USED_THIS_WINDOW_LABEL = "Already used";
export const PICK_REUSE_LIMIT_LABEL = "No uses left";
export const PICK_SPREAD_LABEL = "spread";
export const PICK_CONSENT_TITLE = "No line yet";
export const PICK_CONSENT_BODY =
  "This game’s spread is TBD. Your pick will use the confirmed spread, or Straight up if no eligible pregame quote was provided. Unconfirmed or conflicting quotes await review.";
export const PICK_CONSENT_CONFIRM_LABEL = "Pick it anyway";
export const PICK_CONSENT_CANCEL_LABEL = "Cancel";
export const PICK_REQUIRED_ONE_HINT = "Pick one team.";
export const PICK_DEADLINE_LOCKED_NOTE = "Picks are closed for this round.";
export const PICK_ENTRY_SWITCHER_LABEL = "Which entry are you picking for?";

// ISSUE-777. What a fan sees while they wait for the contest they are already
// in. Names the contest and the day it starts, then says why they cannot pick
// in the one running now.
export function pickWaitingNote(input: {
  contestName: string;
  startDateLabel: string;
}): string {
  return `You're in ${input.contestName}. It starts ${input.startDateLabel}. The contest running now started before you joined.`;
}

/**
 * ISSUE-1042 R3: the Game tab line for an upcoming contest the viewer holds no
 * entry in, so a Commissioner sees the tab change right after creating one.
 */
export function pickUpcomingContestNote(input: {
  contestName: string;
  startDateLabel: string;
}): string {
  return `${input.contestName} starts ${input.startDateLabel}. Picks open when its first round does.`;
}
